import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { appelApi } from './api';

export interface LigneCritere {
  code: string;
  libelle: string;
  description: string;
  poids: number;
  actif: boolean;
}

/** Critère qui entre dans le calcul sans être pondérable (filtre ou contexte). */
export interface CritereHorsScore {
  code: string;
  libelle: string;
  role: 'FILTRE' | 'CONTEXTE';
  explication: string;
}

export interface EtatBareme {
  criteres: LigneCritere[];
  horsScore: CritereHorsScore[];
  totalAttendu: number;
  seuilNotification: number;
  seuilProposition: number;
  limitePropositions: number;
  batchActif: boolean;
  total: number;
  modifieLe: string | null;
  modifiePar: string | null;
}

export interface EntreeBareme {
  criteres: { code: string; poids: number; actif: boolean }[];
  seuilNotification: number;
  seuilProposition: number;
  limitePropositions: number;
  batchActif: boolean;
}

export function useCriteresMatching() {
  return useQuery({
    queryKey: ['matching-criteres'],
    queryFn: () => appelApi<EtatBareme>('/matching-criteres'),
  });
}

export function useModifierBareme() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (entree: EntreeBareme) =>
      appelApi<EtatBareme>('/matching-criteres', { methode: 'PATCH', corps: entree }),
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: ['matching-criteres'] });
      // Les scores affichés dépendent du barème : les vues du pôle commercial
      // doivent repartir des nouvelles pondérations, pas du cache précédent.
      void client.invalidateQueries({ queryKey: ['matching'] });
      void client.invalidateQueries({ queryKey: ['matching-suggestions'] });
    },
  });
}
